/* ============================================
   GLOSSIQUE — Interactive Functionality
   ============================================ */

function initGlossiqueLanding() {
  initCategoryTabs();
  initFAQ();
  initHeroDots();
  initPagination();
  initSwatches();
  initHeroCarouselDepth();
  initCollectionFilters();
  initPDP();
  initDynamicCartCount();
  initMobileNavMenu();
  updateGridProductCount();
  initResponsiveTables();
  cleanVariantUrlParam();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initGlossiqueLanding);
} else {
  initGlossiqueLanding();
}

/* ============================================
   CATEGORY TABS
   ============================================ */
function initCategoryTabs() {
  const tabs = document.querySelectorAll('.tab-btn');

  tabs.forEach(tab => {
    tab.addEventListener('click', () => {
      tabs.forEach(t => t.classList.remove('active'));
      tab.classList.add('active');
      
      // Animate product grid
      const grid = document.getElementById('products-grid');
      grid.style.opacity = '0';
      grid.style.transform = 'translateY(10px)';
      
      setTimeout(() => {
        grid.style.transition = 'all 0.35s ease';
        grid.style.opacity = '1';
        grid.style.transform = 'translateY(0)';
      }, 150);
    });
  });
}

/* ============================================
   FAQ ACCORDION
   Handled per-section in glossique-faq.liquid with dynamic height calculation,
   accordion mode support, and Shopify section lifecycle events.
   ============================================ */
function initFAQ() {
  // Handled in sections/glossique-faq.liquid to prevent double-toggle collisions
}

/* ============================================
   HERO CAROUSEL DOTS
   ============================================ */
function initHeroDots() {
  const dots = document.querySelectorAll('#hero-dots .dot, #hero-dots .dot-bar');
  let currentIndex = 1; // Start at dot-bar

  dots.forEach((dot, index) => {
    dot.addEventListener('click', () => {
      dots.forEach(d => d.classList.remove('active'));
      dot.classList.add('active');
      currentIndex = index;
    });
  });
}

/* ============================================
   PRODUCT PAGINATION
   ============================================ */
function initPagination() {
  let currentPage = 1;
  const totalPages = 3;
  const currentPageEl = document.getElementById('current-page');
  const prevBtn = document.getElementById('pagination-prev');
  const nextBtn = document.getElementById('pagination-next');

  const updateDisplay = () => {
    if (currentPageEl) currentPageEl.textContent = currentPage;
  };

  if (prevBtn) {
    prevBtn.addEventListener('click', () => {
      if (currentPage > 1) {
        currentPage--;
        updateDisplay();
        animateGrid();
      }
    });
  }

  if (nextBtn) {
    nextBtn.addEventListener('click', () => {
      if (currentPage < totalPages) {
        currentPage++;
        updateDisplay();
        animateGrid();
      }
    });
  }

  function animateGrid() {
    const grid = document.getElementById('products-grid');
    grid.style.opacity = '0';
    grid.style.transform = 'translateY(8px)';

    setTimeout(() => {
      grid.style.transition = 'all 0.3s ease';
      grid.style.opacity = '1';
      grid.style.transform = 'translateY(0)';
    }, 150);
  }
}

/* ============================================
   COLOR SWATCH SELECTION
   ============================================ */
function initSwatches() {
  // Hero swatches
  const heroSwatches = document.querySelectorAll('.hero-colors .swatch');
  const heroImages = document.querySelectorAll('.hero-sofa img');
  const heroIdInput = document.querySelector('#hero-add-to-cart-id');
  
  heroSwatches.forEach(swatch => {
    swatch.addEventListener('click', () => {
      heroSwatches.forEach(s => s.classList.remove('active'));
      swatch.classList.add('active');

      const variantImg = swatch.getAttribute('data-variant-img');
      const variantId = swatch.getAttribute('data-variant-id');
      
      if (variantImg && heroImages.length > 0) {
        heroImages.forEach(img => {
          img.style.transition = 'opacity 0.2s ease';
          img.style.opacity = '0.5';
          setTimeout(() => {
            img.src = variantImg;
            img.style.opacity = '1';
          }, 150);
        });
      }
      
      if (heroIdInput && variantId) {
         heroIdInput.value = variantId;
      }
    });
  });
}

function updateGridProductCount() {
  const cards = document.querySelectorAll('#collection-products-grid .product-card');
  const countEl = document.getElementById('total-products-count');
  if (countEl && cards.length > 0) {
    countEl.textContent = 'Total Products: ' + cards.length;
  }
}

/* ============================================
   HERO CAROUSEL DEPTH EFFECT
   ============================================ */
function initHeroCarouselDepth() {
  const carousel = document.getElementById('hero-carousel');
  const track = document.getElementById('hero-carousel-track');

  if (!carousel || !track) return;

  function updateDepth() {
    const carouselRect = carousel.getBoundingClientRect();
    const centerX = carouselRect.left + carouselRect.width / 2;
    const sofas = track.querySelectorAll('.hero-sofa');

    sofas.forEach(sofa => {
      const sofaRect = sofa.getBoundingClientRect();
      const sofaCenterX = sofaRect.left + sofaRect.width / 2;
      const distance = Math.abs(centerX - sofaCenterX);
      const maxDistance = carouselRect.width * 0.5;
      const normalizedDistance = Math.min(distance / maxDistance, 1);

      // Scale: 1.05 at center, 0.85 at edges
      const scale = 1.05 - (normalizedDistance * 0.2);
      // Opacity: 1.0 at center, 0.65 at edges
      const opacity = 1 - (normalizedDistance * 0.35);
      // Z-index: 10 at center, 1 at edges
      const zIndex = Math.round((1 - normalizedDistance) * 10);
      // Shadow intensity: stronger at center
      const shadowBlur = 25 - (normalizedDistance * 15);
      const shadowOpacity = 0.25 - (normalizedDistance * 0.15);

      sofa.style.transform = `scale(${scale})`;
      sofa.style.opacity = opacity;
      sofa.style.zIndex = zIndex;
      sofa.style.filter = `drop-shadow(0 ${10 - normalizedDistance * 4}px ${shadowBlur}px rgba(0,0,0,${shadowOpacity}))`;
    });

    requestAnimationFrame(updateDepth);
  }

  requestAnimationFrame(updateDepth);
}

/* ============================================
   COLLECTION FILTERS & PRICE RANGE SLIDER
   ============================================ */
function initCollectionFilters() {
  const pricingBtn = document.getElementById('filter-pricing-btn');
  const pricingPopover = document.getElementById('pricing-popover');
  const availBtn = document.getElementById('filter-availability-btn');
  const availPopover = document.getElementById('availability-popover');
  const sortBtn = document.getElementById('filter-sort-btn');
  const sortPopover = document.getElementById('sort-popover');

  const closeAllPopovers = () => {
    if (pricingPopover) pricingPopover.hidden = true;
    if (availPopover) availPopover.hidden = true;
    if (sortPopover) sortPopover.hidden = true;
    [pricingBtn, availBtn, sortBtn].forEach(btn => {
      if (btn) {
        btn.setAttribute('aria-expanded', 'false');
        const icon = btn.querySelector('.filter-chevron-icon');
        if (icon) icon.style.transform = 'rotate(0deg)';
      }
    });
  };

  const togglePopover = (btn, popover) => {
    const isHidden = popover.hidden;
    closeAllPopovers();
    popover.hidden = !isHidden;
    btn.setAttribute('aria-expanded', !isHidden ? 'true' : 'false');
    const icon = btn.querySelector('.filter-chevron-icon');
    if (icon) {
      icon.style.transform = !isHidden ? 'rotate(180deg)' : 'rotate(0deg)';
    }
  };

  if (pricingBtn && pricingPopover) {
    pricingBtn.addEventListener('click', (e) => {
      e.stopPropagation();
      togglePopover(pricingBtn, pricingPopover);
    });
  }

  if (availBtn && availPopover) {
    availBtn.addEventListener('click', (e) => {
      e.stopPropagation();
      togglePopover(availBtn, availPopover);
    });
  }

  if (sortBtn && sortPopover) {
    sortBtn.addEventListener('click', (e) => {
      e.stopPropagation();
      togglePopover(sortBtn, sortPopover);
    });
  }

  document.addEventListener('click', (e) => {
    if (!e.target.closest('.filter-dropdown-wrap')) {
      closeAllPopovers();
    }
  });

  const minInput = document.getElementById('price-range-min');
  const maxInput = document.getElementById('price-range-max');
  const minBadge = document.getElementById('price-min-badge');
  const maxBadge = document.getElementById('price-max-badge');
  const track = document.getElementById('range-slider-track');
  const resetBtn = document.getElementById('reset-filters-btn');
  const availCheckboxes = document.querySelectorAll('.filter-avail-input');
  const sortBtns = document.querySelectorAll('.sort-option-btn');
  const totalCountEl = document.getElementById('total-products-count');

  // Detect min and max prices from rendered cards
  const gridContainer = document.getElementById('collection-products-grid');
  const cardsRow = gridContainer ? gridContainer.querySelector('.collection-grid-row') : null;

  function getCards() {
    return Array.from(document.querySelectorAll('#collection-products-grid .product-card'));
  }

  let minBound = 0;
  let maxBound = 2000;
  let userModifiedPrice = false;

  const initialCards = getCards();
  if (initialCards.length > 0) {
    const prices = initialCards.map(c => parseFloat(c.getAttribute('data-price')) || 0).filter(p => p > 0);
    if (prices.length > 0) {
      minBound = Math.floor(Math.min(...prices) / 10) * 10;
      maxBound = Math.ceil(Math.max(...prices) / 10) * 10;
      if (maxBound <= minBound) {
        maxBound = minBound + 500;
      }
    }
  }

  if (minInput && maxInput) {
    minInput.min = minBound;
    minInput.max = maxBound;
    minInput.value = minBound;

    maxInput.min = minBound;
    maxInput.max = maxBound;
    maxInput.value = maxBound;
  }

  // Update slider track & badges
  function updateSliderGraphics() {
    if (!minInput || !maxInput) return;
    let minVal = parseFloat(minInput.value);
    let maxVal = parseFloat(maxInput.value);

    if (minVal > maxVal) {
      minVal = maxVal;
      minInput.value = minVal;
    }
    if (maxVal < minVal) {
      maxVal = minVal;
      maxInput.value = maxVal;
    }

    if (minBadge) minBadge.textContent = `£${Math.round(minVal)}`;
    if (maxBadge) maxBadge.textContent = `£${Math.round(maxVal)}`;

    if (track) {
      const range = maxBound - minBound || 1;
      const minPercent = Math.max(0, Math.min(100, ((minVal - minBound) / range) * 100));
      const maxPercent = Math.max(0, Math.min(100, ((maxVal - minBound) / range) * 100));
      track.style.background = `linear-gradient(to right, #C4C4C4 ${minPercent}%, #1B3D2F ${minPercent}%, #1B3D2F ${maxPercent}%, #C4C4C4 ${maxPercent}%)`;
    }
  }

  // Master Filter & Sort function
  function applyFiltersAndSort() {
    updateSliderGraphics();

    const cards = getCards();
    if (cards.length === 0) return;

    const minPrice = minInput ? parseFloat(minInput.value) : minBound;
    const maxPrice = maxInput ? parseFloat(maxInput.value) : maxBound;

    // Check if price filter is changed by user from boundary
    const isPriceFilterActive = userModifiedPrice && ((minInput && minPrice > minBound) || (maxInput && maxPrice < maxBound));

    const selectedAvail = Array.from(availCheckboxes)
      .filter(cb => cb.checked)
      .map(cb => cb.value);

    // Availability filter is active only if any box is explicitly unchecked
    const isAvailFilterActive = availCheckboxes.length > 0 && Array.from(availCheckboxes).some(cb => !cb.checked);

    let activeSort = 'manual';
    const activeSortBtn = document.querySelector('.sort-option-btn.active');
    if (activeSortBtn) {
      activeSort = activeSortBtn.getAttribute('data-sort') || 'manual';
    }
    const isSortActive = activeSort !== 'manual' && activeSort !== 'default' && activeSort !== 'featured' && activeSort !== '';

    let visibleCards = [];

    cards.forEach(card => {
      const price = parseFloat(card.getAttribute('data-price')) || 0;
      const avail = card.getAttribute('data-available') || 'in_stock';

      const matchPrice = !isPriceFilterActive || (price >= minPrice && price <= maxPrice);
      const matchAvail = !isAvailFilterActive || selectedAvail.includes(avail) || selectedAvail.includes('all');

      if (matchPrice && matchAvail) {
        card.style.display = '';
        card.removeAttribute('hidden');
        visibleCards.push(card);
      } else {
        card.style.display = 'none';
      }
    });

    // Apply Sorting on visible cards
    if (cardsRow && visibleCards.length > 0 && isSortActive) {
      visibleCards.sort((a, b) => {
        const priceA = parseFloat(a.getAttribute('data-price')) || 0;
        const priceB = parseFloat(b.getAttribute('data-price')) || 0;
        const titleA = (a.getAttribute('data-title') || '').toLowerCase();
        const titleB = (b.getAttribute('data-title') || '').toLowerCase();

        if (activeSort === 'price-ascending') {
          return priceA - priceB;
        } else if (activeSort === 'price-descending') {
          return priceB - priceA;
        } else if (activeSort === 'title-ascending') {
          return titleA.localeCompare(titleB);
        } else if (activeSort === 'title-descending') {
          return titleB.localeCompare(titleA);
        }
        return 0;
      });

      // Re-append sorted cards in DOM
      visibleCards.forEach(card => cardsRow.appendChild(card));
    }

    // Update count
    if (totalCountEl) {
      totalCountEl.textContent = 'Total Products: ' + visibleCards.length;
    }

    // Conditionally show Reset button ONLY when filters or custom sorting are applied
    const hasAppliedFilters = isPriceFilterActive || isAvailFilterActive || isSortActive;
    if (resetBtn) {
      resetBtn.style.display = hasAppliedFilters ? 'inline-flex' : 'none';
    }

    // Update Availability Option Labels
    const inStockCount = cards.filter(c => c.getAttribute('data-available') === 'in_stock').length;
    const outOfStockCount = cards.filter(c => c.getAttribute('data-available') === 'out_of_stock').length;

    availCheckboxes.forEach(cb => {
      const label = cb.closest('label');
      const span = label ? label.querySelector('span') : null;
      if (span) {
        if (cb.value === 'in_stock') span.textContent = `In Stock (${inStockCount})`;
        if (cb.value === 'out_of_stock') span.textContent = `Out of Stock (${outOfStockCount})`;
      }
    });
  }

  // Event Listeners
  if (minInput && maxInput) {
    minInput.addEventListener('input', () => {
      userModifiedPrice = true;
      applyFiltersAndSort();
    });
    maxInput.addEventListener('input', () => {
      userModifiedPrice = true;
      applyFiltersAndSort();
    });
  }

  availCheckboxes.forEach(cb => {
    cb.addEventListener('change', applyFiltersAndSort);
  });

  sortBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      sortBtns.forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
      const sortLabelSpan = sortBtn ? sortBtn.querySelector('.sort-btn-label') : null;
      if (sortLabelSpan) {
        const sortMode = btn.getAttribute('data-sort');
        if (sortMode === 'manual' || sortMode === 'featured') {
          sortLabelSpan.textContent = 'Sort By';
        } else {
          sortLabelSpan.textContent = 'Sort By: ' + btn.textContent.trim();
        }
      }
      closeAllPopovers();
      applyFiltersAndSort();
    });
  });

  if (resetBtn) {
    resetBtn.addEventListener('click', () => {
      userModifiedPrice = false;
      if (minInput) minInput.value = minBound;
      if (maxInput) maxInput.value = maxBound;
      availCheckboxes.forEach(cb => cb.checked = true);
      sortBtns.forEach(b => b.classList.remove('active'));
      const defaultSort = document.querySelector('.sort-option-btn[data-sort="manual"]') || sortBtns[0];
      if (defaultSort) defaultSort.classList.add('active');
      const sortLabelSpan = sortBtn ? sortBtn.querySelector('.sort-btn-label') : null;
      if (sortLabelSpan) sortLabelSpan.textContent = 'Sort By';
      closeAllPopovers();
      applyFiltersAndSort();
    });
  }

  // Run on page load
  applyFiltersAndSort();
}

/* ============================================
   PRODUCT DETAIL PAGE (PDP) INTERACTIVITY & BUTTON AUDIT
   ============================================ */
function initPDP() {
  // Thumbnail switching
  const mainImg = document.getElementById('pdp-main-image');
  const thumbs = document.querySelectorAll('.thumb-item');

  thumbs.forEach(thumb => {
    thumb.addEventListener('click', () => {
      const newUrl = thumb.getAttribute('data-img-url');
      if (mainImg && newUrl) {
        mainImg.src = newUrl;
      }
      thumbs.forEach(t => t.classList.remove('active'));
      thumb.classList.add('active');
    });
  });

  // Vertical Thumbnails Arrows (Up / Down)
  const thumbUp = document.querySelector('.thumb-arrow-up');
  const thumbDown = document.querySelector('.thumb-arrow-down');
  const thumbList = document.querySelector('.thumbnails-list');

  if (thumbUp && thumbList) {
    thumbUp.addEventListener('click', () => {
      thumbList.scrollBy({ top: -80, behavior: 'smooth' });
    });
  }
  if (thumbDown && thumbList) {
    thumbDown.addEventListener('click', () => {
      thumbList.scrollBy({ top: 80, behavior: 'smooth' });
    });
  }

  // Quantity Stepper
  const minusBtn = document.getElementById('qty-minus');
  const plusBtn = document.getElementById('qty-plus');
  const qtyCount = document.getElementById('qty-count');
  const qtyInput = document.getElementById('pdp-quantity-input');

  if (minusBtn && plusBtn && qtyCount) {
    let currentQty = parseInt(qtyCount.textContent) || 5;

    const updateQtyDisplay = () => {
      const formatted = currentQty < 10 ? `0${currentQty}` : `${currentQty}`;
      qtyCount.textContent = formatted;
      if (qtyInput) qtyInput.value = currentQty;
    };

    minusBtn.addEventListener('click', () => {
      if (currentQty > 1) {
        currentQty--;
        updateQtyDisplay();
      }
    });

    plusBtn.addEventListener('click', () => {
      currentQty++;
      updateQtyDisplay();
    });
  }

  // Dynamic PDP Variant Selector Handler
  const variantsJsonScript = document.getElementById('pdp-product-variants-json');
  let productVariantsData = [];
  if (variantsJsonScript) {
    try {
      productVariantsData = JSON.parse(variantsJsonScript.textContent);
    } catch (e) {
      console.warn('Failed to parse pdp-product-variants-json', e);
    }
  }

  function filterThumbnailsByColor(colorName, animateScroll = true) {
    if (!colorName || thumbs.length === 0) return;
    
    const normalize = (str) => str ? str.toLowerCase().replace(/gray/g, 'grey').trim() : '';
    const colorNorm = normalize(colorName);
    const colorClean = colorNorm.replace(/[^a-z0-9]/g, '');

    const allColorNames = Array.from(document.querySelectorAll('.color-dot'))
      .map(d => normalize(d.getAttribute('data-color-name')))
      .filter(c => c.length > 0);

    let hasMatchInAlts = false;
    thumbs.forEach(thumb => {
      const altText = normalize(thumb.getAttribute('data-color-alt'));
      const altClean = altText.replace(/[^a-z0-9]/g, '');
      if (altText && (altClean === colorClean || altClean.includes(colorClean) || colorClean.includes(altClean))) {
        hasMatchInAlts = true;
      }
    });

    let firstVisibleThumb = null;

    thumbs.forEach(thumb => {
      const altText = normalize(thumb.getAttribute('data-color-alt'));
      const altClean = altText.replace(/[^a-z0-9]/g, '');

      let shouldShow = false;

      if (hasMatchInAlts) {
        if (altText && (altClean === colorClean || altClean.includes(colorClean) || colorClean.includes(altClean))) {
          shouldShow = true;
        } else {
          shouldShow = false;
        }
      } else {
        let matchesOtherColor = false;
        allColorNames.forEach(otherColor => {
          if (otherColor !== colorNorm) {
            const otherClean = otherColor.replace(/[^a-z0-9]/g, '');
            if (altClean.includes(otherClean) && !altClean.includes(colorClean)) {
              matchesOtherColor = true;
            }
          }
        });
        shouldShow = !matchesOtherColor;
      }

      if (shouldShow) {
        thumb.style.display = 'block';
        if (!firstVisibleThumb) firstVisibleThumb = thumb;
      } else {
        thumb.style.display = 'none';
      }
    });

    if (firstVisibleThumb) {
      thumbs.forEach(t => t.classList.remove('active'));
      firstVisibleThumb.classList.add('active');
      const newImgUrl = firstVisibleThumb.getAttribute('data-img-url');
      if (mainImg && newImgUrl) {
        mainImg.style.transition = 'opacity 0.2s ease';
        mainImg.style.opacity = '0.5';
        setTimeout(() => {
          mainImg.src = newImgUrl;
          mainImg.style.opacity = '1';
        }, 150);
      }
      if (thumbList) thumbList.scrollTo({ top: 0, behavior: animateScroll ? 'smooth' : 'auto' });
    }
  }

  function getSelectedOptions() {
    const opts = {};
    document.querySelectorAll('.size-pill-btn.active, .color-dot.active').forEach(el => {
      const idx = el.getAttribute('data-option-index');
      const val = el.getAttribute('data-value') || el.getAttribute('data-color-name');
      if (idx !== null && idx !== undefined && val) {
        opts[idx] = val;
      }
    });
    return opts;
  }

  function updatePDPVariantState() {
    const selectedOptions = getSelectedOptions();
    let matchedVariant = null;

    if (productVariantsData.length > 0) {
      matchedVariant = productVariantsData.find(variant => {
        return Object.keys(selectedOptions).every(optIdx => {
          const selVal = (selectedOptions[optIdx] || '').toLowerCase().replace(/[^a-z0-9]/g, '');
          const varVal = (variant.options[optIdx] || '').toLowerCase().replace(/[^a-z0-9]/g, '');
          return selVal === varVal || selVal.includes(varVal) || varVal.includes(selVal);
        });
      });
    }

    if (!matchedVariant) {
      const activeDot = document.querySelector('.color-dot.active');
      const activePill = document.querySelector('.size-pill-btn.active');
      const targetId = activeDot?.getAttribute('data-variant-id') || activePill?.getAttribute('data-variant-id');
      if (targetId) {
        matchedVariant = productVariantsData.find(v => String(v.id) === String(targetId));
      }
    }

    if (matchedVariant) {
      const hiddenIdInput = document.getElementById('pdp-variant-id-input') || document.querySelector('#pdp-add-to-cart-form input[name="id"]');
      if (hiddenIdInput) {
        hiddenIdInput.value = matchedVariant.id;
      }

      if (matchedVariant.image && mainImg) {
        mainImg.style.transition = 'opacity 0.2s ease';
        mainImg.style.opacity = '0.5';
        setTimeout(() => {
          mainImg.src = matchedVariant.image;
          mainImg.style.opacity = '1';
        }, 150);
      }

      const currentPriceEl = document.getElementById('pdp-current-price');
      const comparePriceEl = document.getElementById('pdp-compare-price');
      if (currentPriceEl && matchedVariant.price) {
        currentPriceEl.textContent = matchedVariant.price;
      }
      if (comparePriceEl) {
        if (matchedVariant.compare_at_price) {
          comparePriceEl.textContent = matchedVariant.compare_at_price;
          comparePriceEl.style.display = 'inline-block';
        } else {
          comparePriceEl.style.display = 'none';
        }
      }

      if (window.history && window.history.replaceState) {
        const u = new URL(window.location.href);
        if (u.searchParams.has('variant')) {
          u.searchParams.delete('variant');
          const cleanUrl = u.pathname + (u.searchParams.toString() ? '?' + u.searchParams.toString() : '') + u.hash;
          window.history.replaceState({ path: cleanUrl }, '', cleanUrl);
        }
      }
    }
  }

  // Size option pills selection
  const sizeBtns = document.querySelectorAll('.size-pill-btn');
  sizeBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      const group = btn.closest('.option-pills-row, .pdp-option-group');
      if (group) {
        group.querySelectorAll('.size-pill-btn').forEach(b => b.classList.remove('active'));
      } else {
        sizeBtns.forEach(b => b.classList.remove('active'));
      }
      btn.classList.add('active');
      updatePDPVariantState();
    });
  });

  // Color swatch selection
  const colorDots = document.querySelectorAll('.color-dot');
  colorDots.forEach(dot => {
    dot.addEventListener('click', () => {
      const group = dot.closest('.option-swatches-row, .pdp-option-group');
      if (group) {
        group.querySelectorAll('.color-dot').forEach(d => d.classList.remove('active'));
      } else {
        colorDots.forEach(d => d.classList.remove('active'));
      }
      dot.classList.add('active');

      const colorName = dot.getAttribute('data-color-name');
      filterThumbnailsByColor(colorName, true);
      updatePDPVariantState();
    });
  });

  // Run filter on page load for the initially selected color
  const initialActiveDot = document.querySelector('.color-dot.active');
  if (initialActiveDot) {
    const initialColorName = initialActiveDot.getAttribute('data-color-name');
    if (initialColorName) {
      filterThumbnailsByColor(initialColorName, false);
    }
  }

  // Favorite Heart Toggle Button
  const favoriteBtn = document.getElementById('pdp-favorite-btn');
  if (favoriteBtn) {
    favoriteBtn.addEventListener('click', () => {
      favoriteBtn.classList.toggle('active');
      const svgPath = favoriteBtn.querySelector('svg path');
      if (svgPath) {
        if (favoriteBtn.classList.contains('active')) {
          svgPath.setAttribute('fill', '#E52E2E');
          svgPath.setAttribute('stroke', '#E52E2E');
        } else {
          svgPath.setAttribute('fill', 'none');
          svgPath.setAttribute('stroke', 'currentColor');
        }
      }
    });
  }

  // Buy It Now Action Button
  const buyNowBtn = document.getElementById('btn-buy-now');
  if (buyNowBtn) {
    buyNowBtn.addEventListener('click', (e) => {
      e.preventDefault();
      const form = document.getElementById('pdp-add-to-cart-form');
      if (form) {
        const formData = new FormData(form);
        fetch('/cart/add.js', {
          method: 'POST',
          body: formData
        })
        .then(() => {
          window.location.href = '/checkout';
        })
        .catch(() => {
          window.location.href = '/checkout';
        });
      } else {
        window.location.href = '/checkout';
      }
    });
  }

  // Recently Viewed Carousel Arrow Buttons
  const recentlyPrev = document.getElementById('recently-prev');
  const recentlyNext = document.getElementById('recently-next');
  const recentlyGrid = document.getElementById('recently-viewed-grid');

  if (recentlyPrev && recentlyGrid) {
    recentlyPrev.addEventListener('click', () => {
      recentlyGrid.scrollBy({ left: -300, behavior: 'smooth' });
    });
  }
  if (recentlyNext && recentlyGrid) {
    recentlyNext.addEventListener('click', () => {
      recentlyGrid.scrollBy({ left: 300, behavior: 'smooth' });
    });
  }

// PDP Tabs switching (scoped per section)
  document.querySelectorAll('.product-tabs-section').forEach(section => {
    const tabBtns = section.querySelectorAll('.tab-nav-btn');
    const tabPanels = section.querySelectorAll('.tab-panel');

 tabBtns.forEach(btn => {
      btn.addEventListener('click', () => {
        const targetTabId = btn.getAttribute('data-tab');
        tabBtns.forEach(b => b.classList.remove('active'));
        btn.classList.add('active');

      tabPanels.forEach(panel => {
          if (panel.id === targetTabId) {
            panel.classList.add('active');
            panel.hidden = false;
          } else {
            panel.classList.remove('active');
            panel.hidden = true;
          }
        });
      });
    });
  });
}

/* ============================================
   DYNAMIC CART COUNT
   ============================================ */
function initDynamicCartCount() {
  const badge = document.getElementById('header-cart-badge');
  if (!badge) return;

  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      if (cart && cart.item_count > 0) {
        badge.textContent = cart.item_count;
        badge.style.display = 'inline-flex';
      } else {
        badge.textContent = '0';
        badge.style.display = 'none';
      }
    })
    .catch(() => {
      const count = parseInt(badge.textContent);
      if (!count || count === 0) {
        badge.style.display = 'none';
      }
    });
}

/* ============================================
   MOBILE NAVIGATION DRAWER
   ============================================ */
function initMobileNavMenu() {
  const menuBtn = document.querySelector('.mobile-menu-btn');
  const overlay = document.getElementById('mobile-nav-overlay');
  const drawer = document.getElementById('mobile-nav-drawer');
  const closeBtn = document.getElementById('mobile-drawer-close');

  if (!menuBtn || !drawer) return;

  function openMenu() {
    drawer.classList.add('active');
    if (overlay) overlay.classList.add('active');
    document.body.style.overflow = 'hidden';
  }

  function closeMenu() {
    drawer.classList.remove('active');
    if (overlay) overlay.classList.remove('active');
    document.body.style.overflow = '';
  }

  menuBtn.addEventListener('click', (e) => {
    e.preventDefault();
    openMenu();
  });

  if (closeBtn) closeBtn.addEventListener('click', closeMenu);
  if (overlay) overlay.addEventListener('click', closeMenu);
}

/* ============================================
   RESPONSIVE TABLES (BLOG & RTE)
   ============================================ */
function initResponsiveTables() {
  document.querySelectorAll('.rte table, .article-main table, .article-main__rte table').forEach(function(table) {
    if (!table.parentElement.classList.contains('rte__table-wrapper')) {
      var wrapper = document.createElement('div');
      wrapper.className = 'rte__table-wrapper';
      table.parentNode.insertBefore(wrapper, table);
      wrapper.appendChild(table);
    }
  });
}

/* ============================================
   CLEAN VARIANT URL PARAMETER
   ============================================ */
function cleanVariantUrlParam() {
  if (window.location.pathname.includes('/products/') && window.location.search.includes('variant=')) {
    if (window.history && window.history.replaceState) {
      try {
        const url = new URL(window.location.href);
        const vId = url.searchParams.get('variant');
        if (vId) {
          window.__initialVariantId = vId;
          try { sessionStorage.setItem('glossique_target_variant_id', vId); } catch(e) {}
        }
        url.searchParams.delete('variant');
        const cleanUrl = url.pathname + (url.searchParams.toString() ? '?' + url.searchParams.toString() : '') + url.hash;
        window.history.replaceState({}, '', cleanUrl);
      } catch(e) {}
    }
  }
}


